import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddButton from 'shared/ui/AddButton';
import { newJob } from 'store/Jobs/actions';
import { Wrapper, Title } from './styled';
import { selectLimitReached } from 'store/Jobs/selectors';
import { openModal } from 'store/modals/actions';
import { MODAL_UPGRADE_LICENSE } from 'store/modals/modals';
import { useIntl } from 'react-intl';

const Header = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const limitReached = useSelector(selectLimitReached);

  const onClick = () => {
    if (limitReached) dispatch(openModal(MODAL_UPGRADE_LICENSE));
    else dispatch(newJob());
  };

  return (
    <Wrapper>
      <Title>Jobs</Title>
      <AddButton title="Create" onClick={ onClick }>
        {intl.formatMessage({ id: 'common.button.add.job' }) }
      </AddButton>
    </Wrapper>
  );
};
export default Header;
